import {useEffect, useState, useRef, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import ClientViewDragRegion from './components/dragRegion';
import ClientViewPageHeader from './components/header';
import ClientViewPageMain from './components/main';
import ClientViewPageFooter from './components/footer';

import ClientViewPageUpdateModal from './components/update-client'

import ClientViewPageSettings from './components/settings/settings';

import ClientViewLoading from './components/loading';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    console.log(response)

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

function ClientViewPage() {
    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [resizingMode, setResizingMode] = useState(null);

    const [visible, setVisible] = useState(false)
    const [settingsVisibility, setSettingsVisibility] = useState(false)

    const [clientVersion, setClientVersion] = useState("")
    const [canUpdate, setCanUpdate] = useState(false)

    const new_client_version = process.env.REACT_APP_CLIENT_VERSION;

    useEffect(() => {
        async function checkBridge () {
            if (window.pywebview && window.pywebview.api) {
                if (!await checkUserSession()) {navigate("/client-view/login");} else {
                    if (window.pywebview && window.pywebview.api && window.pywebview.api.resize_window) {
                        window.pywebview.api.resize_window(440, 325);
                        window.pywebview.api.toggle_udp_stream(true);
                    }
                }

                setIsClient(true);
            }
        };

        checkBridge();
        window.addEventListener('pywebviewready', checkBridge);

        return () => window.removeEventListener('pywebviewready', checkBridge);
    }, []);

    useEffect(() => {
        async function startClient () {
            if (!await checkUserSession()) {navigate("/client-view/login");}
            else {
                if (window.pywebview && window.pywebview.api && window.pywebview.api.resize_window) {
                    var sizes = [900, 700]
                    
                    if (window.pywebview.api.get_window_size) {
                        sizes = await window.pywebview.api.get_window_size()
                    }

                    await window.pywebview.api.resize_window(sizes[0], sizes[1]);
                    setClientVersion(await window.pywebview.api.get_version())
                }

                setIsReady(true);
            }
        }

        startClient()
    }, [navigate])
    
    const handleCanUpdate = () => {
        if (clientVersion !== new_client_version && clientVersion !== "") {
            setCanUpdate(true)
        } else {
            setCanUpdate(false)
        }
    }

    useEffect(() => {
        if (isReady) {
            handleCanUpdate()
        }
    }, [isReady])

    const currentSize = useRef({ w: window.innerWidth, h: window.innerHeight });
    const startResize = (mode) => (e) => {
        e.preventDefault();
        setResizingMode(mode);
    };

    const stopResize = useCallback(() => {
        setResizingMode(null);
    }, []);

    const onMouseMove = useCallback((e) => {
        if (!resizingMode || !window.pywebview?.api) return;

        let newW = currentSize.current.w;
        let newH = currentSize.current.h;

        if (resizingMode === 'r' || resizingMode === 'rb') {
            newW = e.clientX;
        }
        if (resizingMode === 'b' || resizingMode === 'rb') {
            newH = e.clientY;
        }

        currentSize.current = { w: newW, h: newH };
        window.pywebview.api.resize_window(newW, newH);
    }, [resizingMode]);

    useEffect(() => {
        if (resizingMode) {
            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('mouseup', stopResize);
        }
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', stopResize);
        };
    }, [resizingMode, onMouseMove, stopResize]);

    useEffect(() => {
        console.log("Main: " + settingsVisibility)
    }, settingsVisibility)

    if (!isReady) {
        return <ClientViewLoading />;
    }

    if (!isClient) {
        return (
            <div className="relative flex justify-center items-center min-h-screen w-full flex-col overflow-x-hidden">
                <p className='w-[90%] text-center'>You can view this page only via client windows software</p>
            </div>
        )
    }

    return (
        <>
        <div className="bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 h-screen flex flex-col app-container">
            <ClientViewDragRegion value={0}/>
            <ClientViewPageHeader version={clientVersion} setSettingsVisibility={setSettingsVisibility}/>
            <ClientViewPageMain />
            <ClientViewPageFooter setVisible={setVisible} canUpdate={canUpdate}/>

            <ClientViewPageUpdateModal visible={visible} setVisible={setVisible} />

            <ClientViewPageSettings visible={settingsVisibility} setVisible={setSettingsVisibility} />

            <div className="window-resizers">
                <div className="resizer resizer-r" onMouseDown={startResize('r')}></div>
                <div className="resizer resizer-b" onMouseDown={startResize('b')}></div>
                <div className="resizer resizer-rb" onMouseDown={startResize('rb')}></div>
            </div>
        </div>
        </>
    );
}


export default ClientViewPage;